export default {
  setAccountSettings(state, value) {
    state.accountSettings = value;
  },
  setEmailSenders(state, value) {
    state.emailSenders = value;
  },
  setUsers(state, value) {
    state.users = value;
  },
  setTokenData(state,value){
    try {
      if ('expires_in' in value){
        let now = new Date();
        let durationInMinutes = 2;
        now.setMinutes(now.getMinutes() - durationInMinutes);
        let expiryDate = new Date(now.getTime() + value.expires_in*1000);
        value['expires_at']=expiryDate
      }
      localStorage.setItem("tokenData", JSON.stringify(value));      
      state.tokenData = value;
      
    } catch (error) {
      console.log("Error in set token:",error);
    }
    
  },
  setFeaturePage(state, value) {
    state.featurePage = value;
  },
};
